module.exports = __webpack_public_path__ + "img/lc1.21d4739e.png";